"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiplePinMap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactGoogleMaps = require("@vis.gl/react-google-maps");
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable react/prop-types */
var googleMapUiKey = '';
if (typeof window !== 'undefined') {
  googleMapUiKey = window.GOOGLE_MAPS_API_KEY;
}

/**
 * Renders a map component with multiple pins representing agencies.
 *
 * @param {Object[]} agencyList - The list of agencies to display on the map.
 * @param {string} hoverId - The ID of the agency being hovered over.
 * @param {function} setHoverId - A function to set the ID of the agency being hovered over.
 * @returns {JSX.Element} The rendered map component.
 */
var MultiplePinMap = _ref => {
  var {
    agencyList,
    hoverId,
    setHoverId,
    redoSearchOnClick
  } = _ref;
  console.log(window);
  console.log(googleMapUiKey);
  var bounds = calculateBounds(agencyList);
  var [middleLat, setMiddleLat] = (0, _react.useState)(calculateMiddleLat(bounds));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.APIProvider, {
    apiKey: googleMapUiKey,
    version: "beta"
  }, /*#__PURE__*/_react.default.createElement(CustomMap, {
    bounds: bounds,
    hoverId: hoverId,
    setHoverId: setHoverId,
    middleLat: middleLat,
    setMiddleLat: setMiddleLat,
    agencyList: agencyList,
    redoSearchOnClick: redoSearchOnClick
  })));
};
exports.MultiplePinMap = MultiplePinMap;
var CustomMap = _ref2 => {
  var {
    hoverId,
    setHoverId,
    middleLat,
    agencyList,
    setMiddleLat,
    bounds,
    redoSearchOnClick
  } = _ref2;
  var [shouldShowSearchButton, setShouldShowSearchButton] = (0, _react.useState)(false);
  var [isInitialMapRender, setIsInitialMapRender] = (0, _react.useState)(true);
  var [updatedBounds, setUpdatedBounds] = (0, _react.useState)('');
  var isRedoSearchRef = (0, _react.useRef)(false);
  var isProgrammaticChangeRef = (0, _react.useRef)(false); // Use useRef to track programmatic bounds changes
  var map = (0, _reactGoogleMaps.useMap)();
  (0, _react.useEffect)(() => {
    var isMounted = true;
    if (map && isMounted && !isRedoSearchRef.current) {
      isProgrammaticChangeRef.current = true; // Set flag for programmatic change
      map.fitBounds(bounds);
      setShouldShowSearchButton(false);
    }
    if (isRedoSearchRef.current) {
      isRedoSearchRef.current = false;
    }
    return () => {
      isMounted = false;
    };
  }, [map, agencyList]);
  var mapRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Map, {
    style: {
      width: '100%',
      maxHeight: '65rem',
      overflow: 'hidden',
      position: 'sticky',
      top: '10.2rem',
      minHeight: '65rem'
    },
    defaultBounds: bounds,
    options: {
      mapId: 'a1338bda8d063b0a',
      streetViewControl: false,
      clickableIcons: false,
      zoomControl: true,
      zoomControlOptions: {
        position: _reactGoogleMaps.ControlPosition.TOP_RIGHT
      },
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      fullscreenControl: false,
      cameraControl: false,
      minZoom: 3,
      maxZoom: 18,
      gestureHandling: 'greedy'
    },
    defaultZoom: 12,
    disableDefaultUI: false,
    onZoomChanged: () => {
      setHoverId('');
    },
    onClick: e => {
      if (hoverId !== '') setHoverId('');
    },
    onBoundsChanged: data => {
      setUpdatedBounds(data.detail.bounds);
      setHoverId('');
      if (!isInitialMapRender) {
        if (!isProgrammaticChangeRef.current) setShouldShowSearchButton(true);
      } else {
        setIsInitialMapRender(false);
      }
      setMiddleLat(calculateMiddleLat(data.detail.bounds));
      isProgrammaticChangeRef.current = false;
    }
  }, shouldShowSearchButton && redoSearchOnClick ? /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: () => {
      isRedoSearchRef.current = true;
      setShouldShowSearchButton(false);
      redoSearchOnClick(updatedBounds);
    },
    className: "search-by-coordinates"
  }, "Redo Search In Map") : '', /*#__PURE__*/_react.default.createElement("div", {
    ref: mapRef,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(Loaded, null, /*#__PURE__*/_react.default.createElement(Markers, {
    agencyList: agencyList,
    setHoverId: setHoverId,
    hoverId: hoverId,
    mapRef: mapRef,
    middleLat: middleLat
  }))));
};
var Loaded = _ref3 => {
  var {
    children
  } = _ref3;
  var markers = (0, _reactGoogleMaps.useMapsLibrary)('marker');
  var isLoaded = (0, _reactGoogleMaps.useApiIsLoaded)();
  return isLoaded && markers && children;
};
var Markers = _ref4 => {
  var {
    agencyList,
    setHoverId,
    hoverId,
    mapRef,
    middleLat
  } = _ref4;
  var markersMemo = _react.default.useMemo(() => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, agencyList.map((agency, index) => {
      return /*#__PURE__*/_react.default.createElement(MarkerWithInfoWindow, {
        placement: agency.location.latitude > middleLat ? 'bottom' : 'top',
        key: index,
        index: index,
        position: {
          lat: agency.location.latitude,
          lng: agency.location.longitude
        },
        setHoverId: setHoverId,
        hoverId: hoverId,
        agency: agency,
        mapRef: mapRef,
        show: hoverId === index
      });
    }));
  }, [agencyList, setHoverId, hoverId, mapRef, middleLat]);
  return markersMemo;
};
var MarkerWithInfoWindow = props => {
  var [markerRef, marker] = (0, _reactGoogleMaps.useAdvancedMarkerRef)();
  var {
    index,
    position,
    setHoverId,
    hoverId,
    agency,
    placement,
    mapRef,
    show
  } = props;
  var isActive = hoverId === index;
  var closeClickRef = (0, _react.useRef)(false);
  var ariaLabel = agency === null || agency === void 0 ? void 0 : agency.agencyName;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.AdvancedMarker, {
    onClick: e => {
      var _e$originalEvent;
      e === null || e === void 0 || (_e$originalEvent = e.originalEvent) === null || _e$originalEvent === void 0 || _e$originalEvent.stopPropigation();
      if (hoverId !== '') {
        closeClickRef.current = true;
        setHoverId('');
      }
    },
    key: index,
    position: position,
    ref: markerRef,
    title: 'marker-' + (ariaLabel ? ariaLabel : index)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: ['hover', 'focus', 'click'],
    placement: placement,
    overlay: popoverContent,
    popperConfig: agency,
    onToggle: isHovered => {
      isHovered && !closeClickRef.current ? setHoverId(index) : '';
      closeClickRef.current = false;
    },
    container: mapRef,
    show: show
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: show ? 'icon-map-pin' : 'icon-map-pin-fill',
    id: "pin-".concat(agency !== null && agency !== void 0 && agency.agencyName ? agency === null || agency === void 0 ? void 0 : agency.agencyName : index),
    name: index
  }))));
};
var popoverContent = props => {
  var _props$popper, _agency$location, _agency$location2, _agency$location3, _agency$location4, _agency$location5, _agency$location6, _agency$location7, _agency$location8, _agency$location9;
  var agency = (_props$popper = props.popper) === null || _props$popper === void 0 || (_props$popper = _props$popper.state) === null || _props$popper === void 0 ? void 0 : _props$popper.options;
  var geoFriendlyAddress = (agency === null || agency === void 0 || (_agency$location = agency.location) === null || _agency$location === void 0 ? void 0 : _agency$location.addressLine) + ', ' + (agency === null || agency === void 0 || (_agency$location2 = agency.location) === null || _agency$location2 === void 0 ? void 0 : _agency$location2.city) + ', ' + (agency === null || agency === void 0 || (_agency$location3 = agency.location) === null || _agency$location3 === void 0 ? void 0 : _agency$location3.state) + ' ' + (agency === null || agency === void 0 || (_agency$location4 = agency.location) === null || _agency$location4 === void 0 ? void 0 : _agency$location4.zip);
  var fullAddress = (agency === null || agency === void 0 || (_agency$location5 = agency.location) === null || _agency$location5 === void 0 ? void 0 : _agency$location5.addressLine) + (agency === null || agency === void 0 || (_agency$location6 = agency.location) === null || _agency$location6 === void 0 ? void 0 : _agency$location6.addressLinesExtra) + ', ' + (agency === null || agency === void 0 || (_agency$location7 = agency.location) === null || _agency$location7 === void 0 ? void 0 : _agency$location7.city) + ', ' + (agency === null || agency === void 0 || (_agency$location8 = agency.location) === null || _agency$location8 === void 0 ? void 0 : _agency$location8.state) + ' ' + (agency === null || agency === void 0 || (_agency$location9 = agency.location) === null || _agency$location9 === void 0 ? void 0 : _agency$location9.zip);
  var agentCount = !(agency !== null && agency !== void 0 && agency.count) ? '' : (agency === null || agency === void 0 ? void 0 : agency.count) === 1 ? '1 Financial Professional' : "".concat(agency === null || agency === void 0 ? void 0 : agency.count, " Financial Professionals");
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, _extends({
    className: "popover-finpro"
  }, props, {
    id: "popover-basic"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, null, /*#__PURE__*/_react.default.createElement("a", {
    href: agency === null || agency === void 0 ? void 0 : agency.agencyUrl
  }, /*#__PURE__*/_react.default.createElement("p", null, agency === null || agency === void 0 ? void 0 : agency.agencyName)), /*#__PURE__*/_react.default.createElement("p", null, fullAddress), /*#__PURE__*/_react.default.createElement("a", {
    href: "//www.google.com/maps?q=".concat(geoFriendlyAddress),
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Directions")), agentCount ? /*#__PURE__*/_react.default.createElement("p", {
    className: "popover-agent-count"
  }, /*#__PURE__*/_react.default.createElement("strong", null, agentCount)) : ''));
};

// takes a list of {lat,lng} objects and returns a square boundary around them
var calculateBounds = locationList => {
  // If locationList does not exist return the center of the US
  if (locationList.length === 0) return {
    south: 25.516793518859743,
    west: -109.254815003466,
    north: 48.073769103781984,
    east: -92.775322815966
  };
  var north = locationList[0].location.latitude;
  var south = locationList[0].location.latitude;
  var east = locationList[0].location.longitude;
  var west = locationList[0].location.longitude;
  locationList.forEach(element => {
    if (element.location.latitude > north) north = element.location.latitude;
    if (element.location.latitude < south) south = element.location.latitude;
    if (element.location.longitude > east) east = element.location.longitude;
    if (element.location.longitude < west) west = element.location.longitude;
  });
  return {
    north,
    south,
    east,
    west
  };
};
var calculateMiddleLat = bounds => {
  return bounds.north - (Math.abs(bounds.north) - Math.abs(bounds.south)) / 2;
};